import { render, staticRenderFns } from "./TMenuIconOptionItem.vue?vue&type=template&id=ecd50368&scoped=true&"
import script from "./TMenuIconOptionItem.vue?vue&type=script&lang=js&"
export * from "./TMenuIconOptionItem.vue?vue&type=script&lang=js&"
import style0 from "./TMenuIconOptionItem.vue?vue&type=style&index=0&id=ecd50368&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd50368",
  null
  
)

export default component.exports